export default __webpack_public_path__ + "static/media/president_img.8c979dc7.jpg";